// components/ShipCard.jsx
import React from 'react';
import { Clock, Activity, Ship } from 'lucide-react';

const ShipCard = ({ shipData, side, color }) => {
  const shipName = shipData && shipData.length > 0 ? shipData[0].ship_name : '';
  const projectName = shipData && shipData.length > 0 ? shipData[0].project : '';
  const totalPlannedDays = shipData ? shipData.reduce((sum, task) => {
    const start = new Date(task.start_date);
    const end = new Date(task.end_date);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return sum + (isNaN(diffDays) ? 0 : diffDays);
  }, 0) : 0;
  const totalActualDays = shipData ? shipData.reduce((sum, task) => {
    const actualStart = new Date(task.actual_start);
    const actualFinish = new Date(task.actual_finish);
    const diffTime = Math.abs(actualFinish - actualStart);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return sum + (isNaN(diffDays) ? 0 : diffDays);
  }, 0) : 0;
  const avgActualCompletionPercent = shipData && shipData.length > 0
    ? (shipData.reduce((sum, task) => sum + (task.actual_completion_percent || 0), 0) / shipData.length).toFixed(2)
    : 'N/A';

  return (
    <div className={`bg-white rounded-2xl p-6 border-2 ${color} shadow-lg h-full`}>
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-gray-800">{shipName || `${side} Ship`}</h3>
        <div className={`w-3 h-3 rounded-full ${shipName ? 'bg-green-400' : 'bg-gray-300'}`}></div>
      </div>

      {shipData && shipData.length > 0 ? (
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-blue-50 rounded-lg p-4">
              <div className="flex items-center mb-2">
                <Clock className="w-4 h-4 text-blue-600 mr-2" />
                <span className="text-sm font-medium text-gray-600">Total Planned Days</span>
              </div>
              <div className="text-2xl font-bold text-blue-600">{totalPlannedDays} days</div>
            </div>

            <div className="bg-green-50 rounded-lg p-4">
              <div className="flex items-center mb-2">
                <Activity className="w-4 h-4 text-green-600 mr-2" />
                <span className="text-sm font-medium text-gray-600">Avg. Completion</span>
              </div>
              <div className="text-2xl font-bold text-green-600">{avgActualCompletionPercent}%</div>
            </div>
          </div>

          <div className="space-y-3">
            <div className="flex justify-between items-center py-2 border-b border-gray-100">
              <span className="text-gray-600">Project</span>
              <span className="font-semibold text-gray-800">{projectName}</span>
            </div>
            <div className="flex justify-between items-center py-2 border-b border-gray-100">
              <span className="text-gray-600">Total Actual Days</span>
              <span className="font-semibold text-gray-800">{totalActualDays} days</span>
            </div>
            <p className="text-sm text-gray-600 mt-4">
              Displaying aggregated data from {shipData.length} tasks.
            </p>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center h-64 text-gray-400">
          <div className="text-center">
            <Ship className="w-16 h-16 mx-auto mb-4 text-gray-300" />
            <p>Select a {side.toLowerCase()} ship and project to view details</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShipCard;